import React from 'react'
import { apiFetch } from '../../../fetchApi';

export const createExperience = ({ BeURL, experience, setExperiences, candidateId, showAlert }) => {

    apiFetch(`${BeURL}/candidate-experience`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ experience, candidateId }),
    })
        .then(res => res.json())
        .then(data => {
            showAlert(data.message);
            if (data.success) {
                setExperiences(prev => ([...prev, experience[0]]))
                window.location.reload()

            }
        })
        .catch(err => console.log("Error in Adding Experience", err));
}
